import { api } from "@/http/api-client"
import type { TListAccountsResponse } from "./types"

export type TListAccountsParams = {
  organizationSlug: string
}

export function listAccounts(params: TListAccountsParams) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", params.organizationSlug)

  return api.get<TListAccountsResponse>(
    `/finances/accounts?${searchParams.toString()}`,
  )
}
